import React from 'react';
import auth from "../../consumers/auth";
import Login from '../../subscribers/Login';
import Admin from "./Admin";

const dash = ({currentUser})=>{

    if (currentUser) {
        return <Admin currentUser={currentUser}/>
    }
    return <Login/>


};

const DashBoard = auth(dash);
export default DashBoard;


// WEBPACK FOOTER //
// ./src/admin/subscribers/Dashbord.js